import React from "react";
import {
  CcIconBulb,
  CcIconCheck,
  CcIconDocument,
  CcIconHome,
} from "../../icons";
import { cx } from "../utils";

const iconProps = (size = 14) => ({
  size,
  className: "cc-resident-summary__icon-svg",
  "aria-hidden": true,
});

const IconObservations = (props) => (
  <svg width={14} height={14} viewBox="0 0 18 18" fill="none" {...props}>
    <circle cx="9" cy="9" r="6.25" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="9" cy="9" r="2" fill="currentColor" />
  </svg>
);

const IconFlag = (props) => (
  <svg width={14} height={14} viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M5.5 3.5v11M5.5 3.5h6.5l-1.5 2.5 1.5 2.5H5.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconOverall = (props) => (
  <svg width={14} height={14} viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M9 4.5v5M9 12.25h.01"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
    <circle cx="9" cy="9" r="6.25" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

const IconAction = (props) => (
  <svg width={12} height={12} viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M6 9h6M9 6v6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="9" cy="9" r="6.25" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

const IconSafety = (props) => (
  <svg width={14} height={14} viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M9 2.5l5.5 2.25v4.25c0 3.35-2.35 5.65-5.5 6.75-3.15-1.1-5.5-3.4-5.5-6.75V4.75L9 2.5z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9 7v3.25M9 12.25h.01"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const SUMMARY_ICON_MAP = {
  evaluations: CcIconDocument,
  observations: IconObservations,
  rounds: CcIconCheck,
  ai: CcIconBulb,
  barthel: CcIconHome,
  clinical: CcIconDocument,
  flags: IconFlag,
  safety: IconSafety,
  overall: IconOverall,
  actions: CcIconBulb,
  action: IconAction,
};

/** @param {string} iconId */
const SummaryIcon = ({ iconId, size = 14, className }) => {
  const Icon = SUMMARY_ICON_MAP[iconId];
  if (!Icon) return null;

  if (
    Icon === CcIconDocument ||
    Icon === CcIconBulb ||
    Icon === CcIconCheck ||
    Icon === CcIconHome
  ) {
    return (
      <span className={cx("cc-resident-summary__icon", className)}>
        <Icon {...iconProps(size)} />
      </span>
    );
  }

  return (
    <span className={cx("cc-resident-summary__icon", className)}>
      <Icon
        width={size}
        height={size}
        className="cc-resident-summary__icon-svg"
        aria-hidden
      />
    </span>
  );
};

export default SummaryIcon;
